import 'normalize.css';
import './assets/css/fonts.css';
import './assets/css/index.css';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn:
      'https://25f63433551a479598d3d78a9d4aa5ae@o434224.ingest.sentry.io/5545956',
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(<App />, document.getElementById('root'));
